<template>
  <div>
    <history-filters @change-options='changeOptions' @change-filter-params='changeFilterParams' class='mb-4 text-xs' />
    <comment-input :investment-id='drilldownInvestmentId'></comment-input>
    <div v-if='meetingNoteChecked' >
      <div class='mb-20'>
      <meeting-note-card v-for='meetingNote in meetingNotes'
        :meetingNote='meetingNote'
        :key='`updates-meeting-mote-${meetingNote.id}`'
        @click.native='openMeetingNoteEdit(meetingNote.id)' />
      </div>
      <el-timeline v-if='hasLogs'>
        <timeline-item
          v-for='log in changeLogs'
          :key='`changeLogs-${log.id}`'
          :log='log'>
          <change-log
            :log='log'
            :is-investment='true'
            @toggle-sharing='toggleSharing'
            />
        </timeline-item>
      </el-timeline>
      <portal to='modals'>
        <comment-share-modal
          :shareable-link='shareableLink'
          @modal-close='modalClose'
        />
      </portal>
    </div>
    <div v-else class='mx-auto w-64 text-center'>
      Empty! Please update your filters
    </div>
  </div>
</template>

<script>
import ChangeLog          from '@/components/investment/ChangeLog.vue'
import TimelineItem       from '@/components/investment/TimelineItem.vue'
import CommentInput       from '@/components/CommentInput.vue'
import HistoryFilters     from '@/views/dashboard/HistoryFilters.vue'
import MeetingNoteCard    from '@/components/meeting_notes/MeetingNoteCard.vue'
import CommentShareModal  from '@/components/investment/CommentShareModal.vue'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'InvestmentHistory',
  components: {
    ChangeLog,
    CommentInput,
    HistoryFilters,
    TimelineItem,
    MeetingNoteCard,
    CommentShareModal
  },
  data () {
    return {
      filterParams: {
        filterText: ['comment', 'price', 'meeting note'],
        customFieldTemplateId: 0,
        drilldownInvestmentId: 0,
      },
      shareableLink: '',
      checkedOptions: ['comment', 'price', 'meeting note'],
    }
  },
  watch: {
    drilldownInvestmentId: {
      handler: function (newId) {
        this.filterParams.drilldownInvestmentId = newId
        this.filterChangeLogs(this.filterParams)
        this.getInvestmentMeetingNotes(newId)
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters('investments', [
      'drilldownInvestmentId'
    ]),
    ...mapState('changeLogs', [
      'changeLogs',
    ]),
    ...mapState('meetingNotes', [
      'meetingNotes',
    ]),
    hasLogs () {
      return this.changeLogs.length > 0
    },
    meetingNoteChecked () {
      return this.checkedOptions.includes('meeting note')
    },
  },
  methods: {
    ...mapActions('changeLogs', [
      'getChangeLogs',
      'filterChangeLogs',
    ]),
    ...mapActions('meetingNotes', [
      'getInvestmentMeetingNotes',
      'getMeetingNoteDetails',
    ]),
    changeOptions (checkedOptions) {
      this.checkedOptions = checkedOptions
    },
    changeFilterParams (filterParams) {
      this.filterChangeLogs(filterParams)
      if (this.meetingNoteChecked) {
        this.getInvestmentMeetingNotes(this.drilldownInvestmentId)
      }
    },
    openMeetingNoteEdit (meetingNoteId) {
      this.getMeetingNoteDetails(meetingNoteId)
    },
    toggleSharing(link) {
      this.shareableLink = link
      this.$store.dispatch('modalOpen', {height: 16, width: 24})
    },
    modalClose () {
      this.$store.dispatch('modalClose')
    },
  },
}
</script>
